// import React, { useState } from "react";
// import { Box, Grid } from "@mui/material";
// import StatsComponent from "../RFPDashboard/MainDashboard/TopAnalyticCard.jsx";
// import CampaignUpdateAggregated from "./MainDashboard/CampaignUpdateAggregated.jsx";
// import RadarChart from "./MainDashboard/RadarChart.jsx";
// import img from "../../shared/assets/icons/empty.png";
// import { PlusIcon } from "../../shared/assets/icons";
// import BurgerChart from "./MainDashboard/BurgerChart.jsx";
// import MainDashBoardMapLocation from "./MainDashboard/MainDashBoardMapLocation.jsx";
// import TeamMemberMainDashBoard from "./MainDashboard/TeamMemberMainDashBoard.jsx";

// const SideContent = () => {
//   const [data, setData] = useState(true);

//   return (
//     <>
//       {data ? (
//         <div className="m-2">
//           {/* Top Analytics Section */}
//           <Grid>
//             <Grid item xs={12}>
//               <Box sx={{ borderRadius: "8px", }}>
//                 <StatsComponent />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Middle Section: Campaign Updates, Radar Chart, Burger Chart */}
//           <Grid container spacing={2}  >
//             <Grid item xs={12} sm={4} md={2} lg={2}>

//               <CampaignUpdateAggregated />
//             </Grid>
//             <Grid item xs={12} sm={8} md={5} lg={5}>
//               <Box
//                 sx={{
//                   backgroundColor: "#fff",
//                   borderRadius: "8px",

//                   height: "400px",
//                 }}
//               >
//                 <RadarChart />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={12} md={5} lg={5}>
//               <Box
//                 sx={{
//                   backgroundColor: "#fff",
//                   borderRadius: "8px",

//                   height: "400px",

//                 }}
//               >
//                 <BurgerChart />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Bottom Section: Map and Team Member */}
//           <Grid container spacing={1} sx={{ mt: 1 }}>
//             <Grid item xs={12} md={8}>
//               <Box sx={{ borderRadius: "8px", height: "100%" }}>
//                 <MainDashBoardMapLocation />
//               </Box>
//             </Grid>
//             <Grid item xs={12} md={4} >
//               <Box
//                 sx={{
//                   borderRadius: "8px",

//                   height: "100%",
//                 }}
//               >
//                 <TeamMemberMainDashBoard />
//               </Box>
//             </Grid>
//           </Grid>
//         </div >
//       ) : (
//         // Empty State UI
//         <div
//           className="m-auto"
//           style={{
//             height: "85vh",
//             justifyContent: "center",
//             display: "flex",
//             alignItems: "center",
//             overflowX: "hidden",

//           }}
//         >
//           <div className="min-h-[405px] max-w-[305px] flex flex-col p-5 items-center justify-center shadow-lg">
//             <div className="min-h-[200px] max-w-[250px]">
//               <img src={img} alt="empty Dashboard" />
//             </div>
//             <h1 className="mt-2">Generate Your First RFP</h1>
//             <p className="text-[12px] text-center">
//               Streamline your process, make it easier than ever to manage and execute your advertising strategy.
//             </p>
//             <a
//               className="btn flex items-center mt-5 gap-2 rounded-lg shadow-lg text-white px-4 py-2"
//               style={{ backgroundColor: "var(--primary-color)" }}
//             >
//               <PlusIcon color="white" size="14px" /> Add New Campaign
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default SideContent;

import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Header from "../RFPDashboard/ClientDashboard/Header.js";
import CampaignUpdateAggregated from "./MainDashboard/CampaignUpdateAggregated.jsx";
import RadarChart from "./MainDashboard/RadarChart.jsx";
import img from "../../shared/assets/icons/empty.png";
import { PlusIcon } from "../../shared/assets/icons";
import BurgerChart from "./MainDashboard/BurgerChart.jsx";
import OnGoingCampaigns from "./ClientDashboard/OnGoingCampaigns.js";
import Notifications from "./ClientDashboard/Notifications.js";
import Spend from "./ClientDashboard/Spend.js";
import LineChart from "./ClientDashboard/LineChart.js";
import axios from "axios";
import { Link } from "react-router-dom";
import { generateToken } from "../../shared/utils/GenerateTokenFirebase.jsx";
import CircularProgress from "@mui/material/CircularProgress";

const SideContent = ({ ongoingCampaigns }) => {
  const [data, setData] = useState(true);
  const [totalCampaign, setTotalCampaign] = useState("");
  const [totalSpent, setTotalSpent] = useState("");
  const [jobsCreated, setJobsCreated] = useState("");
  const [stateWisePrice, setStateWisePrice] = useState([]);
  const [ongoingCampaign, setOnGoingCampaign] = useState([]);
  const [spendAllocation, setSpendAllocation] = useState([]);
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const serverURL = process.env.REACT_APP_URL;

  const storedClientId = localStorage.getItem("clientId");
  const token = localStorage.getItem("token");

  const fetchAllData = async (id) => {
    try {
      const response = await axios.get(
        `${serverURL}/organization/stats/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.success) {
        setTotalCampaign(response?.data?.totalCampaigns);
        setTotalSpent(response?.data?.totalSpent);
        setJobsCreated(response?.data?.totalJobsCreated);
        setStateWisePrice(response?.data?.statewisePrice);
        setOnGoingCampaign(response?.data?.ongoingCampaigns);
        setSpendAllocation(response?.data?.productTypeAndCreationMonthPrice);
        setNotificationData(response?.data?.allNotificationData);

        // oldData = response?.data?.data;
      } else {
        // setSlotLoading(false);
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
      // setSlotLoading(false);
    } finally {
      setIsLoading(false); // Mark loading as complete
    }
  };

  const fetchOrganizationID = async () => {
    try {
      const token = localStorage.getItem("token");

      // Check if token exists
      if (!token) {
        throw new Error("No authentication token found. Please log in.");
      }

      const response = await axios.get(
        `${serverURL}/client/dashboard/${storedClientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Check if the response is successful
      if (response.data.success) {
        const orgId = response?.data?.data?.organizationId;
        const { _id } = response.data.data;

        const fireBaseToken = await generateToken();
        if (fireBaseToken) {
          const response2 = await axios.put(`${serverURL}/client/edit/${_id}`, {
            fireBaseToken,
          });
        }

        if (orgId) {
          // setOrganizationId(orgId);
          await fetchAllData(orgId);
        } else {
          throw new Error("Organization ID not found in the response.");
        }
      } else {
        throw new Error("Failed to fetch organization data.");
      }
    } catch (err) {
      console.error("Error fetching Organization ID:", err.message || err);
    }
  };

  // Trigger fetchTeamMembers on component mount
  useEffect(() => {
    fetchOrganizationID();
  }, []); // Ensure the dependency array is properly closed

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center h-[85vh]">
          <CircularProgress />
        </div>
      ) : totalCampaign > 0 ? (
        <div className="m-2">
          {/* Top Analytics Section */}
          <Grid>
            <Grid item xs={12}>
              <Box sx={{ borderRadius: "8px" }}>
                <Header
                  totalSpent={totalSpent}
                  jobsCreated={jobsCreated}
                  totalCampaign={totalCampaign}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Middle Section: Campaign Updates, Radar Chart, Burger Chart */}
          <Grid container spacing={2} className=" flex justify-between">
            <Grid item xs={12} sm={7} md={8} lg={8}>
              <LineChart spendAllocation={spendAllocation} />
            </Grid>
            <Grid item xs={12} sm={5} md={4} lg={4}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",

                  height: "450px",
                }}
              >
                <Notifications notificationData={notificationData} />
              </Box>
            </Grid>
          </Grid>

          {/* Bottom Section: Map and Team Member */}
          <Grid
            container
            spacing={2}
            sx={{ mt: 1 }}
            className=" flex justify-between"
          >
            <Grid item xs={12} sm={7} md={7} lg={6}>
              <Spend stateWisePrice={stateWisePrice} />
            </Grid>
            <Grid item xs={12} sm={5} md={5} lg={6}>
              <Box
                sx={{
                  borderRadius: "8px",

                  height: "100%",
                }}
              >
                <OnGoingCampaigns ongoingCampaign={ongoingCampaigns} />
              </Box>
            </Grid>
          </Grid>
        </div>
      ) : (
        // Empty State UI
        <div
          className="m-auto"
          style={{
            height: "85vh",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            overflowX: "hidden",
          }}
        >
          <div className="min-h-[405px] max-w-[305px] flex flex-col p-5 items-center justify-center shadow-lg">
            <div className="min-h-[200px] max-w-[250px]">
              <img src={img} alt="empty Dashboard" />
            </div>
            <h1 className="mt-2">Generate Your First RFP</h1>
            <p className="text-[12px] text-center">
              Streamline your process, make it easier than ever to manage and
              execute your advertising strategy.
            </p>
            <Link
              to="/user/createRFP"
              className="btn flex items-center mt-5 gap-2 rounded-lg shadow-lg text-white px-4 py-2"
              style={{ backgroundColor: "var(--primary-color)" }}
            >
              <PlusIcon color="white" size="14px" /> Add New RFP
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default SideContent;
